import Vue from 'vue';
import App from './App.vue';
import router from './router'; // 引入路由
import ElementUI from 'element-ui'; // 引入 Element UI 组件库
import 'element-ui/lib/theme-chalk/index.css'; // 引入 Element UI 的样式
Vue.config.productionTip = false;

Vue.use(ElementUI); // 注册 Element UI
new Vue({
  router, // 注入路由
  render: (h) => h(App),
}).$mount('#app');
